import { Icon, Text } from '@rbilabs/universal-components';
import { spacing } from '@rbilabs/universal-components/themes';
import { StyleSheet, View } from 'react-native';

import { useProductWizardContext } from 'pages/menu/components/product-wizard';
import { useLocale } from 'state/intl';
import { t } from 'state/intl/translations';
import { ILocalizedMenuEntry, IndexedMenu } from 'state/unified-menu/types';
import { useUnifiedMenuContext } from 'state/unified-menu/unified-menu-context';
import { primitive } from 'styles/constants/primitives';
import { Region } from 'utils/environment/types';

import { SlotsSelections } from '../../product-wizard/types';
import { computeComboSodium } from '../../product-wizard/utils';
const SODIUM_LIMIT = 2300;

function hasExcessSodium(
  menu: IndexedMenu<ILocalizedMenuEntry>,
  selectedProduct: ILocalizedMenuEntry,
  slotsSelections: SlotsSelections
) {
  let totalSodium = 0;

  if (selectedProduct.type === 'ITEM') {
    totalSodium = selectedProduct.nutrition?.nutrients?.sodium ?? 0;
  } else if (selectedProduct.type === 'COMBO') {
    totalSodium = computeComboSodium(menu, selectedProduct, slotsSelections);
  }

  return totalSodium > SODIUM_LIMIT;
}

export const OverSodiumLimitWarning = () => {
  const { region } = useLocale();
  const { indexedMenu } = useUnifiedMenuContext();
  const { selectedProduct, slotsSelections } = useProductWizardContext();

  if (region !== Region.US) {
    return null;
  }

  if (!hasExcessSodium(indexedMenu, selectedProduct, slotsSelections)) {
    return null;
  }

  return (
    <View style={styles.container}>
      <Icon variant="sodiumFlag" testID="sodium-flag" size={{ base: '18px', md: '26px' }} />
      <Text fontSize={primitive.fontSizes.lg}>
        {t('sodiumWarning', 'Sodium Warning').toUpperCase()}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    marginVertical: spacing.$4,
    gap: 4,
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
});
